import { render, staticRenderFns } from "./WorkOrderPaginador.vue?vue&type=template&id=bb50fa04&scoped=true"
import script from "./WorkOrderPaginador.vue?vue&type=script&lang=js"
export * from "./WorkOrderPaginador.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderPaginador.vue?vue&type=style&index=0&id=bb50fa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50fa04",
  null
  
)

export default component.exports